// Slide 6 - Certgen
import { ExternalLink } from "lucide-react";

export default function Slide6() {
  const images = ["/certgen/certgen_1.png", "/certgen/certgen_2.png"];

  return (
    <section className="w-full max-w-[1400px] relative z-10">
      <div className="absolute -right-16 -top-12 w-72 h-72 bg-gradient-to-br from-indigo-800/20 to-sky-700/10 rounded-full blur-3xl pointer-events-none opacity-60" />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
        {/* Left: Content (glass card) */}
        <div className="self-start flex flex-col space-y-5 p-6 md:p-8 rounded-3xl bg-gradient-to-br from-white/6 via-white/3 to-transparent backdrop-blur-xl border border-white/12 shadow-2xl relative overflow-hidden group hover:border-white/20 transition-all duration-500">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/4 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 pointer-events-none" />

          <div className="relative z-10">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-white/10 to-white/4 rounded-full text-white text-xs uppercase tracking-wider font-bold border border-white/20 shadow-lg">
                Product
              </span>
            </div>

            <div className="mt-6">
              <h2
                className="text-white font-black leading-none tracking-tight drop-shadow-lg"
                style={{ fontSize: "clamp(36px,5vw,60px)" }}
              >
                CertGen
              </h2>
              <div className="inline-block px-3 py-1 bg-white/10 rounded-lg mt-2">
                <span className="text-white/70 uppercase tracking-widest text-[11px] font-bold">
                  Certificate generator
                </span>
              </div>
            </div>

            <p className="text-white/90 text-[16px] leading-7 mt-6">
              Modern <span className="keyword">certificate generation</span>{" "}
              service — <span className="keyword">templated PDFs</span>,{" "}
              <span className="keyword">secure verification</span>, and a{" "}
              <span className="keyword">lightweight CMS</span> for managing
              certificate templates and content.
            </p>

            <div className="h-px bg-white/6 my-6" />

            <div className="flex items-center gap-3">
              <div className="text-white/70 text-sm font-semibold">
                Setup in
              </div>
              <span className="relative flex items-center">
                <span className="absolute inline-flex h-3.5 w-3.5 rounded-full bg-white/60 opacity-75 animate-ping" />
                <span className="relative inline-block h-2.5 w-2.5 rounded-full bg-white shadow" />
              </span>
              <div className="text-white font-medium">10 mins</div>
            </div>

            <div className="mt-6">
              <a
                href="https://certgen.org"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white text-gray-900 px-6 py-2.5 rounded-full font-semibold shadow-md transition-transform hover:scale-105 border border-white/20"
              >
                Visit Website
                <ExternalLink size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Right: Images column */}
        <div className="space-y-4">
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={images[0]}
              alt="Certgen hero"
              className="w-full h-auto object-contain rounded-2xl"
              style={{ aspectRatio: "16/9" }}
            />
          </div>

          <div className="grid grid-cols-1 gap-4">
            <figure className="rounded-xl overflow-hidden shadow-lg">
              <img
                src={images[1]}
                alt="Certgen detail"
                className="w-full h-full object-contain rounded-lg"
                style={{ aspectRatio: "16/9" }}
              />
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}
